import "core-js/modules/es.array.push.js";
import axios from "axios";
import moment from "moment";
import { splitTeacherCourses } from "@/utils/teacherCourseSeparator";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      courseOptions: JSON.parse(sessionStorage.getItem("courseOptions")),
      courseColor: JSON.parse(sessionStorage.getItem("courseColor")),
      lightColor: {
        "#ff6086": "#ffedf0",
        "#2651ff": "#e4e9ff",
        "#fd9f02": "#fff4e4",
        "#09bd3c": "#e2f2e6",
        "#007bff": "#e2f1ff"
      },
      // 第一次登录,展示教程(共6步)
      showTutorial: 1,
      campusList: JSON.parse(sessionStorage.getItem("campusList")),
      selectedCampusId: "",
      campusNames: {},
      selectedDate: "",
      // 教室课表
      // campusId: {classroomList:[], classroomCourseList: {}}
      campusClassrooms: {},
      earliestHour: 8,
      latestHour: 18,
      hourRange: [4, 5, 6, 7, 8],
      // 教室课表/老师课表 切换
      showCourseTable: "教室",
      //老师列表
      teacherList: [],
      // teacherId转换为teacherName
      teacherNames: {},
      // 老师课表
      campusTeacherCourse: {}
    };
  },
  async mounted() {
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    const slowStepMs = 500;
    const logStep = label => {
      const t = performance.now();
      const dt = t - stepT0;
      if (dt > slowStepMs) {
        console.log(`[home mounted] ${label}: ${dt.toFixed(1)}ms (>${slowStepMs}ms)`);
      }
      stepT0 = t;
    };

    //不是第一次登录，不需要教程
    this.showTutorial = 0;
    logStep("设置 showTutorial");

    // 查询校区
    if (!this.campusList) {
      await this.queryCampus();
    }
    logStep("queryCampus（含已缓存跳过）");
    // 构造校区id转校区名称映射
    for (let i = 0; i < this.campusList.length; i++) {
      this.campusNames[this.campusList[i].campus.id] = this.campusList[i].campus.name;
    }
    // console.log("获取校区列表this.campusList:", this.campusList);
    logStep("构建 campusNames");

    // 初始校区
    if (this.campusList.length > 0) {
      this.selectedCampusId = this.campusList[0].campus.id;
    }
    // console.log("this.selectedCampusId:", this.selectedCampusId);
    logStep("初始化 selectedCampusId");

    // 初始日期 今天
    this.selectedDate = moment().format("YYYY-MM-DD");
    logStep("初始化 selectedDate");

    // 科目可在其他页面中变更，进入课表时必须刷新，不能只使用本会话旧缓存。
    await this.getCourseOptions();
    logStep("getCourseOptions");

    // 获取老师列表
    await this.getTeacherList();
    logStep("getTeacherList");
    await Promise.all([
    // 获取教室列表, 教室课表
    this.getClassroomCourse(),
    // 获取老师课表
    this.getAllTeacherCourse()]);
    logStep("并行：getClassroomCourse / getAllTeacherCourse");
    console.log(`[home mounted] 总用时: ${(performance.now() - mountT0).toFixed(1)}ms`);
  },
  methods: {
    clickNext(index) {
      this.showTutorial = index + 1;
      console.log("this.showTutorial:", this.showTutorial);
    },
    // 查询校区
    async queryCampus() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/queryCampus", params);
        if (resp1.data.code == "0000") {
          console.log("获取校区:", resp1.data.data);
          this.campusList = resp1.data.data;
          sessionStorage.setItem("campusList", JSON.stringify(resp1.data.data));
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取教室列表
    // 获取某天某个校区，每个教室安排的课程
    async getClassroomCourse() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let campusIds = [];
        for (let i = 0; i < this.campusList.length; i++) {
          campusIds.push(this.campusList[i].campus.id);
        }
        let params = {
          date: this.selectedDate,
          campusIds: campusIds,
          institution: this.institution
        };
        console.log(`${moment().format('YYYY-MM-DD HH:mm:ss')} 开始调用 getClassroomCourse`);
        let resp1 = await axios.post("https://backend.wonology.com/home/getClassroomCourse", params);
        if (resp1.data.code == "0000") {
          this.campusClassrooms = resp1.data.data;

          // console.log("this.campusClassrooms:", this.campusClassrooms);

          // 查询是否有早于8点 或 晚于18点的课程
          if (this.campusClassrooms[this.selectedCampusId]) {
            for (let classroomId in this.campusClassrooms[this.selectedCampusId].classroomCourseList) {
              // 每节课
              for (let i in this.campusClassrooms[this.selectedCampusId].classroomCourseList[classroomId]) {
                let period = this.campusClassrooms[this.selectedCampusId].classroomCourseList[classroomId][i].period;
                let startTime = period.split("-")[0];
                startTime = parseInt(startTime.split(":")[0]);
                if (startTime < this.earliestHour) {
                  this.earliestHour = startTime;
                }
                this.earliestHour = Math.floor(this.earliestHour / 2) * 2;
                let endTime = period.split("-")[1];
                // 如果不是整点，hour要加1
                if (endTime.split(":")[1] != "00") {
                  endTime = parseInt(endTime.split(":")[0]) + 1;
                } else {
                  endTime = parseInt(endTime.split(":")[0]);
                }
                if (endTime > this.latestHour) {
                  this.latestHour = endTime;
                }
                this.latestHour = Math.ceil(this.latestHour / 2) * 2;
              }
            }
          }

          // 构造时间点跨度
          this.hourRange = [];
          for (let i = this.earliestHour / 2; i <= this.latestHour / 2 - 1; i++) {
            this.hourRange.push(i);
          }
        } else {
          console.log("调用getClassroomCourse出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          flag: "onlyActive" //(筛选出启用的)
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = splitTeacherCourses(this.teacherList[i].coursesStr, this.courseOptions);
          }

          // console.log("获取老师列表 this.teacherList:", this.teacherList);

          this.teacherNames = {};
          for (let i = 0; i < this.teacherList.length; i++) {
            this.teacherNames[this.teacherList[i].id] = this.teacherList[i].name;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    // 获取所有老师的课程安排
    async getAllTeacherCourse() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let campusIds = [];
        for (let i = 0; i < this.campusList.length; i++) {
          campusIds.push(this.campusList[i].campus.id);
        }
        let params = {
          date: this.selectedDate,
          campusIds: campusIds,
          institution: this.institution
        };
        // console.log(`${moment().format('YYYY-MM-DD HH:mm:ss')} 开始调用 getTeacherCourse`)
        let resp1 = await axios.post("https://backend.wonology.com/home/getTeacherCourse", params);
        if (resp1.data.code == "0000") {
          this.campusTeacherCourse = resp1.data.data;
        } else {
          console.log("调用getTeacherCourse出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }

        // console.log("this.campusTeacherCourse:", this.campusTeacherCourse);
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error " + error);
      } finally {
        loading.close();
      }
    },
    // 获取科目清单，科目颜色
    async getCourseOptions() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/queryCourses", params);
        if (resp1.data.code == "0000") {
          if (resp1.data.data) {
            this.courseOptions = JSON.parse(resp1.data.data[0].courses);
            this.courseColor = JSON.parse(resp1.data.data[0].courseColor);
            sessionStorage.setItem("courseOptions", JSON.stringify(this.courseOptions));
            sessionStorage.setItem("courseColor", JSON.stringify(this.courseColor));
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 切换日期
    async handleDateChange() {
      // 获取教室课表
      await this.getClassroomCourse();
      // 获取老师课表
      await this.getAllTeacherCourse();
    },
    // 切换校区
    async handleChangeCampus() {
      // 获取教室课表
      await this.getClassroomCourse();
      // 获取老师课表
      await this.getAllTeacherCourse();
    },
    // 点击校区下拉框，展开下拉菜单
    clickCampusSelect() {
      // 通过 this.$refs 获取 el-select 实例
      const select = this.$refs.campusSelectRef;
      if (select) {
        // 先聚焦（可选，但推荐）
        select.focus();
        // 调用 toggleMenu 展开/收起下拉菜单
        select.toggleMenu();
      }
    },
    //列表横纵滚动
    handleScroll(event) {
      const scrollLeft = event.target.scrollLeft;
      const scrollTop = event.target.scrollTop;

      // 移动固定表头
      this.$refs.fixedHeader.style.transform = `translateX(-${scrollLeft}px)`;

      // 移动固定列
      this.$refs.fixedColumn.style.transform = `translateY(-${scrollTop}px)`;
    },
    // 教室课表/老师课表 切换
    classroomTeacherChange(flag) {
      this.showCourseTable = flag;
    },
    // 点击div展开选择日期
    selectDate() {
      // 通过 ref 获取 el-date-picker 实例
      const datePicker = this.$refs.datePickerRef;
      // console.log("datePicker:", datePicker);
      if (datePicker) {
        // 调用 focus 方法展开日期选择器
        datePicker.focus();
      }
    },
    async formerDate() {
      const formerDay = moment(this.selectedDate).subtract(1, "days").format("YYYY-MM-DD");
      this.selectedDate = formerDay;
      await this.handleDateChange();
    },
    async nextDate() {
      const nextDay = moment(this.selectedDate).add(1, "days").format("YYYY-MM-DD");
      this.selectedDate = nextDay;
      await this.handleDateChange();
    }
  }
};